export default [
    {
        path: '/document-history/change-history-branch',
        name: 'document-history-change-history-branch',
        component: () => import('@src/document-history/change-document-history-branch.vue'),
        meta: {
            title: 'Vorgang wechseln',
            role: 'ROLE_ROOT',
        },
    },
];
